import services from './services.js';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
//组件
import baseInfoForm from 'agent-base-info';
import contactForm from 'agent-contact';
import businessForm from '../business-form/index.vue';
import selectStaffDialog from 'selectStaffDialog';

export default {
    mixins: [services],
    components: {
        'base-info-form': baseInfoForm,
        'contact-form': contactForm,
        'business-form': businessForm,
        selectStaffDialog
    },
    props: {
        isReadOnly: {
            default: false
        },
        value: {
            type: Boolean,
            required: true
        },
        editData: {
            type: Object,
            default: null
        },
        modify: {
            type: Boolean,
            default: false
        },
        major: {
            type: Boolean,
            default: false
        }
    },
    created() {
        this.visiable = this.value;
    },
    data() {
        return {
            visiable: false,
            baseInfo: null,
            contact: null,
            business: null,
            edLoading: false
        };
    },
    watch: {
        value: function(val) {
            this.visiable = this.value;
        },
        visiable: function(val) {
            this.$emit('input', val);
            this.initData();
            if (!val) {
                this.resetForm();
            }
        }
    },
    methods: {
        showSelectStaffDialog() {
            this.$refs.refSelectStaffDialog.show();
        },
        selectedStaff(item) {
            //lg(item);
            this.$refs.baseInfo.setStaffInfo(item);
        },
        showLoading() {
            this.edLoading = true;
        },
        hideLoading() {
            this.edLoading = false;
        },
        resetForm() {
            this.$nextTick(() => {
                this.$refs.baseInfo.resetFields();
                this.$refs.contact.resetFields();
                this.$refs.business.resetFields();
            });
        },
        initData() {
            if (!isCorrectVal(this.editData)) return;

            this.$nextTick(() => {

                this.baseInfo = util.filterAndSetData(this.$refs.baseInfo.refsGetInitData(), this.editData);
                this.contact = util.filterAndSetData(this.$refs.contact.getInitResultData(), this.editData);

                this.business = {
                    CustomerSource_Id: this.editData.CustomerSource_Id, //必填，客户来源
                    CustomerLevel_Id: this.editData.CustomerLevel_Id, //必填，意向等级
                    RegisteredCapital: this.editData.RegisteredCapital, //注册资本
                    EmployeeNums: this.editData.EmployeeNums, //人数规模
                    Qualification: this.editData.Qualification, //公司资质
                };
            });
        },
        close() {
            this.visiable = false;
        },
        closeCallBack() {
            this.resetForm();
            this.$emit('closeDialog'); //向上派发 toggle事件
        },
        submit() {

            let baseInfoForm = this.$refs.baseInfo.validate();
            let contactForm = this.$refs.contact.validate();
            let businessForm = this.$refs.business.validate();

            if (baseInfoForm && contactForm && businessForm) {
                let params = Object.assign({}, baseInfoForm, contactForm, businessForm);
                params.IsMajor = (this.$route.name === '重点客户列表') ? 1 : 0;
                if (!this.modify) {
                    this.addAgent(params);
                } else {
                    this.updateAgent(params);
                }
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/components/edit-dialog/vm.js